import { BaseService, Service } from "/@/cool";
@Service("modelRepairCheckItem")
class ModelRepairCheckItem extends BaseService {

	constructor() {
		super();

		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}

		//this.permission["add"] = prefix + "add";
		this.permission["update"] = prefix + "update";
		this.permission["page"] = prefix + "page";
		this.permission["list"] = prefix + "list";
		this.permission["info"] = prefix + "info";
	}

	first(params: any) {
		return this.request({
			url: "/first",
			method: "POST",
			data: {
				...params
			}
		});
	}
}
export default ModelRepairCheckItem;